// extracted by mini-css-extract-plugin
export default {"errorContainer":"error_errorContainer__Zx+o6","errorTitle":"error_errorTitle__LXZMl","errorMessage":"error_errorMessage__I2Lik","errorButton":"error_errorButton__3Nv9d"};